import { number, object, ObjectSchema, string } from 'yup';

import { RemitServiceLinePayload } from '@/types/billing';
import { transformEmptyStringToNull } from '@/utils/transformEmptyStringToNull';

export const RemitServiceLineSchema: ObjectSchema<
  Omit<RemitServiceLinePayload, 'id' | 'claim_rows'>
> = object().shape({
  remit_claim: number().integer().required(),
  start_on: string()
    .required()
    .matches(/^\d{4}-\d{2}-\d{2}$/, 'Must be a valid date (YYYY-MM-DD)'),
  end_on: string()
    .required()
    .matches(/^\d{4}-\d{2}-\d{2}$/, 'Must be a valid date (YYYY-MM-DD)'),
  code: string().max(5).min(1).required().transform(transformEmptyStringToNull),
  modifier: string().max(20).nullable().transform(transformEmptyStringToNull),
  qualifier: string().max(2).nullable().transform(transformEmptyStringToNull),
  allowed_units: number().integer().min(-2147483648).max(2147483647).nullable(),
  billed_units: number().integer().min(-2147483648).max(2147483647).nullable(),
  charge_amount: string().max(10).nullable().transform(transformEmptyStringToNull),
  charge_amount_in_cents: number().min(-2147483648).max(2147483647).nullable(),
  paid_amount: string().max(10).nullable().transform(transformEmptyStringToNull),
  paid_amount_in_cents: number().min(-2147483648).max(2147483647).nullable(),
  revenue_code: string().max(10).nullable().transform(transformEmptyStringToNull)
});
